import { SuppliesSubscriptionOrderInterval } from "@redotech/crdb-enums/product/supplies-subscription-order-interval";
import { locationIdFormat } from "@redotech/redo-inventory-id";
import { suppliesSubscriptionIdFormat } from "@redotech/redo-marketplace-id";
import { productIdFormat } from "@redotech/redo-product-id";
import * as z from "zod";

// Mirrors the checkout shipping-address shape used for non-OMS destinations.
const SubscriptionAddressSchema = z.object({
  name: z.string(),
  address1: z.string(),
  address2: z.string().nullable(),
  city: z.string(),
  province: z.string(),
  zip: z.string(),
  countryCode: z.string(),
  phone: z.string().nullable(),
});

export const createSuppliesSubscription = {
  name: "createSuppliesSubscription" as const,
  input: z.object({
    suppliesProductId: productIdFormat.schema,
    quantity: z.number().int().min(1),
    orderInterval: z.enum(SuppliesSubscriptionOrderInterval),
    orderIntervalFrequency: z.number().int().min(1),
    // OMS merchants ship to a warehouse location; others enter a custom address.
    destination: z.discriminatedUnion("kind", [
      z.object({
        kind: z.literal("warehouse"),
        warehouseLocationId: locationIdFormat.schema,
      }),
      z.object({
        kind: z.literal("customAddress"),
        address: SubscriptionAddressSchema,
      }),
    ]),
  }),
  output: z.object({
    suppliesSubscriptionId: suppliesSubscriptionIdFormat.schema,
  }),
};
